import api from '../../../App/socket';


export const getFinalConfirmation = params => api.send({
    api: 'db',
    model: 'Lead_finance',
    action: 'Read',
    options: {
        limit: 1,
        attributes: 'all',
        where: {
            _id: params._id,
        },
    },
});

export const setFinalConfirmation = params => api.send({
    api: 'db',
    model: 'Lead_finance',
    action: params.action,
    options: {
        create: params.create,
        update: params.update,
        where: params.where,
        include: {
            model: 'User',
            path: 'bought_info.bought_by_driver',
            attributes: ['person.first_name', 'person.last_name'],
        },
    },

});

export const transferLeadToBike = params => api.send({
    api: 'module',
    module: 'Leads',
    classMethod: 'TransferLeadToBike',
    options: {
        where: {
            _id: params.lead_id,
        },
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/final_confirmation_request.js